import React from "react";
import axios from "axios";

import { connect } from "react-redux";

import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { setMovies, setFilter } from "../../actions/actions";

import MoviesList from "../movies-list/movies-list";
import ProfileView from "../profile-view/profile-view";
import LoginView from "../login-view/login-view";
import { MovieView } from "../movie-view/movie-view";
import { RegistrationView } from "../registration-view/registration-view";
import { Navigation } from "../navbar/navbar";
import { GenreView } from "../genre-view/genre-view";
import { DirectorView } from "../director-view/director-view";
import { Container } from "react-bootstrap";

import "./main-view.scss";

class MainView extends React.Component {
	constructor() {
		super();
		this.state = {
			favoriteMovies: [],
			user: null,
		};
	}
	componentDidMount() {
		let accessToken = localStorage.getItem("token");
		if (accessToken !== null) {
			this.setState({
				user: localStorage.getItem("user"),
			});
			this.getMovies(accessToken);
		}
	}

	getMovies(token) {
		axios
			.get("https://lilac-kingfisher-sari.cyclic.app/movies", {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((response) => {
				this.props.setMovies(response.data);
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	handleFavorite = (movieId, action) => {
		const { user, favoriteMovies } = this.state;
		const accessToken = localStorage.getItem("token");
		if (accessToken !== null && user !== null) {
			// Add MovieID to Favorites
			if (action === "add") {
				this.setState({ favoriteMovies: [...favoriteMovies, movieId] });
				axios
					.post(
						`https://lilac-kingfisher-sari.cyclic.app/users/${user}/movies/${movieId}`,
						{},
						{
							headers: { Authorization: `Bearer ${accessToken}` },
						}
					)
					.then((res) => {
						console.log(`Movie added to ${user} favorite movies`);
					})
					.catch((err) => {
						console.log(err);
					});

				// Remove MovieID from Favorites
			} else if (action === "remove") {
				this.setState({
					favoriteMovies: favoriteMovies.filter((id) => id !== movieId),
				});
				axios
					.delete(
						`https://lilac-kingfisher-sari.cyclic.app/users/${user}/movies/${movieId}`,
						{
							headers: { Authorization: `Bearer ${accessToken}` },
						}
					)
					.then((res) => {
						console.log(`Movie removed from ${user} favorite movies`);
					})
					.catch((err) => {
						console.log(err);
					});
			}
		}
	};
	/* When a user successfully logs in, this function updates the `user`
  property in state to that *particular user*/
	onLoggedIn(authData) {
		console.log(authData);
		this.setState({
			user: authData.user.username,
		});

		localStorage.setItem("token", authData.token);
		localStorage.setItem("user", authData.user.username);
		this.getMovies(authData.token);
	}
	onLoggedOut() {
		localStorage.removeItem("token");
		localStorage.removeItem("user");
		this.setState({
			user: null,
		});
		window.open("/", "_self");
	}

	render() {
		let { movies } = this.props;
		let { user } = this.state;
		let { favoriteMovies } = this.state;

		return (
			<Router>
				<Navigation user={user} />
				<Container fluid>
					<Route
						exact
						path="/"
						render={() => {
							if (!user)
								return (
									<LoginView onLoggedIn={(user) => this.onLoggedIn(user)} />
								);
							if (movies.length === 0) return <div className="main-view" />;
							return <MoviesList movies={movies} />;
						}}
					/>

					<Route
						path="/register"
						render={() => {
							if (user) return <Redirect to="/" />;
							return <RegistrationView />;
						}}
					/>

					<Route
						path={`/users/${user}`}
						render={({ history }) => {
							if (!user) return <Redirect to="/" />;
							return (
								<ProfileView
									movies={movies}
									onBackClick={history.goBack}
									favoriteMovies={favoriteMovies}
									handleFavorite={this.handleFavorite}
								/>
							);
						}}
					/>

					<Route
						path="/movies/:movieId"
						render={({ match, history }) => {
							if (!user)
								return (
									<LoginView onLoggedIn={(user) => this.onLoggedIn(user)} />
								);
							if (movies.length === 0) return <div className="main-view" />;

							return (
								<MovieView
									movie={movies.find((m) => m._id === match.params.movieId)}
									isFavorite={favoriteMovies.includes(match.params.movieId)}
									onBackClick={history.goBack}
									handleFavorite={this.handleFavorite}
								/>
							);
						}}
					/>

					<Route
						path="/directors/:name"
						render={({ match, history }) => {
							if (!user)
								return (
									<LoginView onLoggedIn={(user) => this.onLoggedIn(user)} />
								);
							if (movies.length === 0) return <div className="main-view" />;
							return (
								<DirectorView
									director={
										movies.find((m) => m.director.name === match.params.name)
											.director
									}
									directorMovies={movies.filter(
										(m) => m.director.name === match.params.name
									)}
									onBackClick={() => history.goBack()}
								/>
							);
						}}
					/>

					<Route
						path="/genres/:name"
						render={({ match, history }) => {
							if (!user)
								return (
									<LoginView onLoggedIn={(user) => this.onLoggedIn(user)} />
								);
							if (movies.length === 0) return <div className="main-view" />;
							return (
								<GenreView
									genreMovies={movies.filter(
										(movie) => movie.genre.name === match.params.name
									)}
									genre={
										movies.find((m) => m.genre.name === match.params.name).genre
									}
									onBackClick={() => history.goBack()}
								/>
							);
						}}
					/>
				</Container>
			</Router>
		);
	}
}

let mapStateToProps = (state) => {
	return { movies: state.movies };
};

export default connect(mapStateToProps, { setMovies, setFilter })(MainView);
